<template>
    <div v-if="nb_remaining_by_timestamp > 0">
        <h6>Coureurs a venir <b-badge class="bg-blue-500 text-white">{{ nb_remaining_by_timestamp }}</b-badge>
        </h6>
        <div>Basé sur leur heure de passage estimée</div>
        <b-table id="table-remaining-by" :items="coureurs" :fields="fields" :per-page="perPageBy"
            :current-page="currentPageBy">
            <template #cell(estimation)="row">
                {{ get_difference_time(row.item.timestamp) }}
            </template>
            <template #cell(coureur)="row">
                {{ row.item.coureur }}
            </template>
            <template #cell(fiche)="row">
                <button class="inline-btn py-1 my-0" @click="openFicheCoureur(row.item.id_coureur)"><b-icon
                        icon="person" aria-hidden="true"></b-icon> Ouvrir sa fiche</button>
            </template>
        </b-table>
        <b-pagination v-model="currentPageBy" :total-rows="nb_remaining_by_timestamp" :per-page="perPageBy"
            aria-controls="table-remaining-by" size="sm" class="mt-2"></b-pagination>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['coureurs'],
    data() {
        return {
            currentPageBy: 1,
            perPageBy: 5,
            fields: [
                { key: 'estimation', label: 'Estimation' },
                { key: 'coureur', label: 'Coureur' },
                { key: 'fiche', label: 'Fiche' },
            ]
        }
    },
    computed: {
        nb_remaining_by_timestamp() {
            if (!this.coureurs) {
                return 0;
            }
            return this.coureurs.length;
        }
    },
    methods: {
        openFicheCoureur(idCoureur) {
            var fiche_path = "fiche/" + idCoureur;
            this.$router.push({ path: fiche_path });
        },
        get_difference_time(timestamp) {
            //timestamp is a unix timestamp
            var date = new Date(timestamp * 1000);
            return "Attendu " + moment(date).fromNow();
        }
    }
}
</script>

<style lang="scss" scoped></style>